import { gql } from '@apollo/client';

export const updateSecurityQuestionsGql = gql`
    mutation UpdateSecurityQuestions($userId: String!, $questions: InputUpdateSecurityQuestions!) {
        updateUserSecurityQuestions(userId: $userId, questions: $questions)
    }
`;
